export enum MandatorParameterTypes {
  BOOL = 'BOOL',
  DATE = 'DATE',
  TEXT = 'TEXT',
  EMPTY = ''
} 